// src/SidebarComponents.jsx
import React from "react";
import { createPortal } from "react-dom";

// 1. The Styles Component
export const SidebarStyles = () => (
  <style>{`
    :root {
      --nav-bg: #07090cff;
      --nav-bg-2: #37465eff;
      --nav-surface: #24324a;
      --nav-hover: #2b3c58;
      --nav-active: #324665;
      --nav-border: #ffffff14;
      --nav-text: #e9f1fb;
      --nav-muted: #a9b8cf;
      --nav-danger: #f87171;
      --nav-danger-hover: #f8717120;
    }
    .sidebar { width: 280px; position: sticky; top: 0; height: 100vh; display: flex; flex-direction: column; background: linear-gradient(180deg, var(--nav-bg) 0%, var(--nav-bg-2) 100%); color: var(--nav-text); border-right: 1px solid var(--nav-border); }
    .brand { padding: 16px 18px; border-bottom: 1px solid var(--nav-border); display: flex; align-items: center; gap: 12px; flex-shrink: 0; }
    .brand .logo { width: 38px; height: 38px; border-radius: 12px; display: grid; place-items: center; background: #2a3b59; font-size: 18px; }
    .brand .title { margin: 0; font-size: 18px; font-weight: 700; }
    .menu-list { padding: 16px; margin: 0; list-style: none; overflow-y: auto; }
    .menu-link { display: flex; align-items: center; gap: 12px; padding: 12px; border-radius: 10px; text-decoration: none; color: var(--nav-text); margin-bottom: 8px; transition: background 0.15s ease; cursor: pointer; }
    .menu-link:hover { background: var(--nav-hover); }
    .menu-link.active { background: var(--nav-active); font-weight: 600; }
    .sidebar-footer { margin-top: auto; padding: 12px; border-top: 1px solid var(--nav-border); background: #2b374bff; }
    .user-tile { display: flex; align-items: center; gap: 12px; padding: 10px; border-radius: 12px; background: var(--nav-surface); cursor: pointer; transition: background-color 0.15s ease; }
    .user-tile:hover { background-color: var(--nav-hover); }
    .user-avatar { width: 38px; height: 38px; border-radius: 50%; background: #33425f; display: grid; place-items: center; font-weight: 700; overflow: hidden; flex-shrink: 0; }
    .user-avatar img { width: 100%; height: 100%; object-fit: cover; }
    .user-meta { overflow: hidden; }
    .user-meta .name { font-weight: 700; line-height: 1.2; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }
    .user-meta .email { color: var(--nav-muted); font-size: 13px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }
    .user-actions { margin-top: 12px; display: flex; flex-direction: column; gap: 4px; }
    .action-link { display: flex; align-items: center; gap: 10px; width: 100%; padding: 10px 12px; border-radius: 8px; background: none; border: none; color: var(--nav-muted); text-align: left; cursor: pointer; font-size: 14px; text-decoration: none; transition: background-color 0.15s ease, color 0.15s ease; }
    .action-link:hover { background: var(--nav-hover); color: var(--nav-text); }
    .action-link.active { background: var(--nav-active); color: var(--nav-text); font-weight: 600; }
    .action-link i { font-size: 16px; }
    .action-link.text-danger { color: var(--nav-danger); }
    .action-link.text-danger:hover { background: var(--nav-danger-hover); color: var(--nav-danger); }
    .locations-panel { margin: 8px 0 14px 0; padding: 8px; background: linear-gradient(180deg, #1f2a42, #18202d); border-radius: 8px; }
    .locations-empty { color: var(--nav-muted); padding: 12px; text-align: center; font-size: 13px; }
    .locations-list { display: flex; flex-direction: column; gap: 8px; max-height: none; overflow: visible; padding-right: 6px; }
    .loc-item { border-radius: 8px; padding: 10px; background: #24334b; }
    .loc-item-header { display:flex; justify-content: space-between; align-items: center; gap: 8px; }
    .loc-item-title { font-weight: 600; }
    .loc-item-body { margin-top: 8px; color: var(--nav-muted); font-size: 13px; }
    .survey-entry { display: flex; align-items: center; justify-content: space-between; gap: 8px; padding: 6px 8px; border-radius: 6px; background: rgba(15, 12, 46, 0.86); margin-top: 8px; }
    .survey-left { display: flex; align-items: center; gap: 8px; }
    .survey-label { display: inline-block; padding: 6px 10px; border-radius: 10px; background: #e8eefc; color: #0f172a; font-weight: 700; font-size: 13px; letter-spacing: 0.6px; }
    .survey-right { display: flex; flex-direction: column; align-items: flex-end; gap: 6px; }
    .survey-modified { font-size: 11px; color: var(--nav-muted); margin-top: 2px; line-height: 1; white-space: nowrap; opacity: 0.95; }
    .status-dot { width:10px; height:10px; border-radius:50%; display:inline-block; margin-right:6px; }
    .survey-time-text { color:var(--nav-text); font-size:13px; }
    .survey-actions button { background:transparent; border:none; color:var(--nav-muted); cursor:pointer; padding:6px; border-radius:6px; }
    .add-location { display:flex; gap:8px; align-items:center; justify-content:center; padding:8px 10px; border-radius:8px; background: #2a455f; cursor:pointer; margin-top:10px; font-weight:600; }
    .loc-loading { padding: 12px; text-align:center; color:var(--nav-muted); }
    .small-muted { color: var(--nav-muted); font-size: 12px; margin-top:6px; }
    .status-requested { background: #2563eb; }
    .status-surveyed { background: #10b981; }
    .status-processed { background: #f59e0b; }
    .status-uploaded { background: #7c3aed; }
    .status-verified { background: #6b7280; }
    .status-cancelled { background: #ef4444; }
    .spinner { width: 36px; height: 36px; border-radius: 50%; border: 4px solid rgba(0,0,0,0.08); border-top-color: rgba(16,185,129,1); animation: spin 1s linear infinite; }
    @keyframes spin { to { transform: rotate(360deg); } }
    .skeleton-line { background: linear-gradient(90deg, rgba(0,0,0,0.04) 20%, rgba(0,0,0,0.06) 50%, rgba(0,0,0,0.04) 80%); background-size: 200% 100%; animation: shimmer 1.2s linear infinite; }
    @keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
  `}</style>
);

// 2. Add Location Modal Component
export const AddLocationModal = ({
  show,
  onClose,
  onSubmit,
  name,
  setName,
  fileRef,
  fileName,
  setFileName,
  error,
  uploading,
}) => {
  if (!show) return null;

  return createPortal(
    <div
      id="add-location-modal"
      className="modal-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add-location-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "rgba(10, 12, 18, 0.45)",
        pointerEvents: "auto",
        zIndex: 2147483647,
      }}
    >
      <div
        className="modal-card"
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          width: 560,
          maxWidth: "100%",
          background: "#fff",
          borderRadius: 8,
          boxShadow: "0 16px 40px rgba(2,6,23,0.5)",
          overflow: "hidden",
        }}
      >
        <div
          className="modal-header"
          style={{
            padding: "14px 18px",
            background: "#f6f8fb",
            borderBottom: "1px solid #e6e9ef",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h3 id="add-location-title" style={{ margin: 0, fontSize: 16, color: "#1f2937" }}>
            Add New Location
          </h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: 18,
              color: "#475569",
            }}
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <form onSubmit={onSubmit}>
          <div className="modal-body" style={{ padding: "18px", background: "#fff" }}>
            <label style={{ display: "block", marginBottom: 8, color: "#334155", fontSize: 13 }}>
              Location Name
            </label>
            <input
              id="add-location-name"
              type="text"
              placeholder="e.g., East Ridge Farm"
              value={name}
              onChange={(e) => setName(e.target.value)}
              aria-label="Location name"
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: 6,
                border: "1px solid #d1d5db",
                background: "#2b2b2b10",
                color: "#0f172a",
              }}
            />

            <label style={{ display: "block", marginTop: 14, marginBottom: 8, color: "#334155", fontSize: 13 }}>
              Boundary (GeoJSON)
            </label>

            <div
              className="file-drop"
              onClick={() => fileRef.current?.click()}
              style={{
                marginTop: 6,
                padding: 20,
                borderRadius: 8,
                border: "2px dashed #dbe6f3",
                background: "#fafafa",
                textAlign: "center",
                color: "#64748b",
                cursor: "pointer",
              }}
            >
              <div style={{ fontSize: 14, marginBottom: 6 }}>
                <i className="bi bi-upload" style={{ marginRight: 8 }} />
                Click to upload a .geojson file
              </div>
              <div style={{ fontSize: 12, color: "#94a3b8" }}>Or drag & drop onto this box</div>

              <input
                ref={fileRef}
                type="file"
                accept=".geojson,application/geo+json,application/json"
                style={{ display: "none" }}
                onChange={(e) => {
                  const file = e.target.files?.[0];
                  setFileName(file ? file.name : "");
                }}
              />

              {fileName && (
                <div style={{ marginTop: 8, fontSize: 13, color: "#111827" }}>
                  Selected file: <strong>{fileName}</strong>
                </div>
              )}
            </div>

            {error && (
              <div style={{ color: "#b91c1c", marginTop: 12, fontSize: 13 }} role="alert">
                {error}
              </div>
            )}
          </div>

          <div
            className="modal-footer"
            style={{
              padding: "12px 18px",
              display: "flex",
              gap: 8,
              justifyContent: "flex-end",
              background: "#fff",
              borderTop: "1px solid #eceef4",
            }}
          >
            <button
              type="button"
              onClick={onClose}
              className="btn secondary"
              style={{
                padding: "8px 14px",
                borderRadius: 6,
                background: "#f3f4f6",
                border: "1px solid #e6e9ef",
                color: "#475569",
                cursor: "pointer",
                fontWeight: 600,
              }}
              disabled={uploading}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn primary"
              style={{
                padding: "8px 14px",
                borderRadius: 6,
                background: uploading ? "#9bb4ff" : "#2563eb",
                border: "none",
                color: "#fff",
                cursor: name.trim() && !uploading ? "pointer" : "not-allowed",
                fontWeight: 600,
                opacity: name.trim() ? 1 : 0.6,
              }}
              disabled={!name.trim() || uploading}
            >
              {uploading ? "Adding…" : "Add Location"}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

// 3. Request Survey Modal Component
export const SurveyModal = ({
  show,
  target,
  onClose,
  onConfirm,
  date,
  setDate,
  remark,
  setRemark,
  loading,
  submitting,
  status,
}) => {
  if (!show || !target) return null;

  return createPortal(
    <div
      id="survey-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="survey-modal-title"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        background: "rgba(10,12,18,0.45)",
        pointerEvents: "auto",
        zIndex: 2147483647,
      }}
    >
      <div
        id="survey-modal-inner"
        onMouseDown={(e) => e.stopPropagation()}
        style={{
          width: 560,
          maxWidth: "100%",
          background: "#fff",
          borderRadius: 8,
          boxShadow: "0 18px 50px rgba(2,6,23,0.45)",
          overflow: "hidden",
        }}
      >
        <div style={{ padding: "14px 18px", background: "#f6f8fb", borderBottom: "1px solid #e6e9ef", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h3 id="survey-modal-title" style={{ margin: 0, fontSize: 16, color: "#0f172a" }}>Request New Survey</h3>
          <button type="button" onClick={onClose} aria-label="Close" style={{ background: "transparent", border: "none", cursor: "pointer", color: "#475569", fontSize: 18 }}>
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <div style={{ padding: 18 }}>
          <p style={{ margin: 0, color: "#374151" }}>
            Create a survey for location: <strong>{target.title}</strong>
          </p>

          {loading ? (
            <div style={{ marginTop: 16, display: "flex", flexDirection: "column", gap: 10, alignItems: "stretch" }}>
              <div style={{ display: "flex", justifyContent: "center", padding: 18 }}>
                <div className="spinner" aria-hidden="true" />
              </div>
              <div className="skeleton-line" style={{ height: 44, borderRadius: 8 }} />
              <div className="skeleton-line" style={{ height: 72, borderRadius: 8 }} />
              <div style={{ color: "#6b7280", fontSize: 13 }}>Loading survey info…</div>
            </div>
          ) : (
            <>
              <label style={{ display: "block", marginTop: 12, marginBottom: 6, color: "#6b7280", fontSize: 13 }}>Survey date</label>
              <input
                id="survey-date-input"
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                style={{ width: "100%", padding: "8px 10px", borderRadius: 6, border: "1px solid #e6e9ef" }}
              />

              <label style={{ display: "block", marginTop: 12, marginBottom: 6, color: "#6b7280", fontSize: 13 }}>Remark</label>
              <textarea
                id="survey-remark-input"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Add a note about this survey (e.g. access instructions, contact person)..."
                rows={3}
                style={{ width: "100%", padding: "8px 10px", borderRadius: 6, border: "1px solid #e6e9ef", resize: "vertical", fontSize: 14, color: "#0f172a" }}
              />

              <div style={{ marginTop: 10, color: "#6b7280", fontSize: 13 }}>
                The survey entry will be stored with status <strong>Requested</strong>.
              </div>

              {status && (
                <div style={{ marginTop: 12, color: submitting ? "#0ea5a6" : "#16a34a", fontWeight: 600 }}>{status}</div>
              )}
            </>
          )}
        </div>

        <div style={{ padding: "12px 18px", display: "flex", gap: 8, justifyContent: "flex-end", borderTop: "1px solid #eceef4", background: "#fff" }}>
          <button type="button" onClick={onClose} disabled={submitting} style={{ padding: "8px 12px", borderRadius: 6, background: "#f3f4f6", border: "1px solid #e6e9ef", color: "#475569", cursor: "pointer", fontWeight: 600 }}>
            Cancel
          </button>
          <button type="button" onClick={onConfirm} disabled={submitting} style={{ padding: "8px 12px", borderRadius: 6, background: submitting ? "#9be7c7" : "#10b981", border: "none", color: "white", cursor: "pointer", fontWeight: 700 }}>
            {submitting ? "Requesting…" : "Confirm Request"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};